import { useGetReceptionVolumeByMonthQuery } from "@/redux/services/recordApi";
import { Alert, Card, Flex, Spin } from "antd";
import ReactEcharts from "echarts-for-react";

export function TravelPeopleMonthLine({ selectedDateByMonth }) {
	const {
		data: monthData,
		isError: isMonthError,
		isLoading: isMonthLoading,
	} = useGetReceptionVolumeByMonthQuery(selectedDateByMonth);

	let xAxisData = [];
	let seriesData = [];

	if (monthData) {
		Object.entries(monthData).forEach(([key, value]) => {
			xAxisData.push(key);
			seriesData.push(value);
		});
	}

	const getOption = () => {
		let option = {
			xAxis: {
				type: "category",
				boundaryGap: false,
				data: xAxisData,
			},
			yAxis: {
				type: "value",
				name: "人数",
				nameLocation: "end",
				nameTextStyle: {
					fontSize: 14,
					padding: [0, 0, 10, 0], // 上右下左
				},
			},
			series: [
				{
					data: seriesData,
					type: "line",
					areaStyle: {},
					smooth: true,
					label: {
						show: true,
						position: "top",
					},
					emphasis: {
						focus: "series",
					},
				},
			],
			tooltip: {
				trigger: "axis",
				axisPointer: {
					type: "cross",
					label: {
						backgroundColor: "#6a7985",
					},
				},
			},
		};
		return option;
	};
	return (
		<Card
			style={{
				marginTop: "30px",
				marginBottom: "30px",
				border: "1px solid grey",
			}}
			title="旅行人数"
		>
			{isMonthError && (
				<Alert
					message="Error"
					description="Something went wrong ..."
					type="error"
					showIcon
				/>
			)}

			{isMonthLoading && (
				<Flex
					justify="center"
					align="center"
					style={{ width: "100%", height: "50vh" }}
				>
					<Spin size="large" />
				</Flex>
			)}

			{isMonthError != null && monthData != null && (
				<div
					style={{ width: "100%", margin: "0 auto", height: "350px" }}
				>
					<ReactEcharts
						option={getOption()}
						style={{ width: "100%", height: "100%" }}
					/>
				</div>
			)}
		</Card>
	);
}
